var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IconBtn',{attrs:{"title":"Unverified (100)","icon":"mdi-delete","loading":_vm.loading},on:{"click":_vm.submit}}),(_vm.total > 0)?_c('div',{staticClass:"my-2"},[_vm._v(_vm._s(_vm.deleted)+"/"+_vm._s(_vm.total))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }